(function(angular) {
    'use strict';
    class SearchEmptyState {
        constructor($translate, $mdDialog, $scope, $window, FeedbackService) {
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
            this.$scope = $scope;
            this.$window = $window;
            this.FeedbackService = FeedbackService;
            this.FeedbackService.initializeMissingContact();
        }

        clearSearch() {
            this.$scope.$emit('clearAll');
        }

        handleOpenHelpCenter() {
            this.$window.open('https://help.meltwater.com/');
        }

        handleMediaResearchHelp() {
            this.$window.open('https://help.meltwater.com/en/articles/4064620-how-to-do-media-research-in-meltwater-to-discover-relevant-influencers-and-publications');
        }

        submitMissingContact() {
            this.FeedbackService.initializeMissingContact();
            this.FeedbackService.showFeedbackModal();
        }

        submitMissingSource() {
            this.FeedbackService.initializeMissingSource();
            this.FeedbackService.showFeedbackModal();
        }

    }

    angular.module('MW.Influencers.SearchEmptyState', [
        'ngMaterial',
        'MW.Influencers.FeedbackService',
    ])
    .component('searchEmptyState', {
        bindings: {
            contactSearch: '=',
            relevantSearch: '='
        },
        controller: ['$translate', '$mdDialog', '$scope', '$window', 'FeedbackService', SearchEmptyState],
        template: `
            <div class="search-empty-state-container">
                 <div ng-if="$ctrl.contactSearch"class="empty-state-img empty-contact"></div>
                 <div ng-if="!$ctrl.contactSearch"class="empty-state-img empty-source"></div>
                 <div class='search-empty-title', translate>icm-search__empty-state--header</div>
                 <div class='search-empty-description', translate>icm-search__empty-state--description</div>
                 <div class='search-empty-button-container'>
                    <div class='search-empty-action-buttons'>
                        <md-button ng-if="!$ctrl.relevantSearch && $ctrl.contactSearch", ng-click="$ctrl.submitMissingContact()" class="mw-button mw-button--outlined">
                            <span translate>icm-search__empty-state--missing-contact-button</span>
                        </md-button>
                        <md-button ng-if="!$ctrl.relevantSearch && !$ctrl.contactSearch", ng-click="$ctrl.submitMissingSource()" class="mw-button mw-button--outlined">
                            <span translate>icm-search__empty-state--missing-source-button</span>
                        </md-button>
                        <md-button class="mw-button md-primary", ng-click="$ctrl.clearSearch()">
                            <span translate>icm-search__empty-state--clear-search-button</span>
                        </md-button>
                    </div>
                    <div class='button-divider'></div>
                    <div class='search-empty-help-buttons'>
                        <md-button class="mw-button mw-button--link md-primary", ng-click="$ctrl.handleMediaResearchHelp()">
                            <span translate>icm-search__empty-state--media-research-help-button</span>
                        </md-button>
                        <span class="help-buttons-divider">|</span>
                        <md-button class="mw-button mw-button--link md-primary", ng-click="$ctrl.handleOpenHelpCenter()">
                            <span translate>icm-search__empty-state--help-center-button</span>
                        </md-button>
                    <div class='search-empty-help-buttons'>

                 </div>
            </div>
        `
    });
})(window.angular);
